module.exports = __webpack_public_path__ + "img/add.4138f21e.svg";